import { render, staticRenderFns } from "./ChangeEmailNew.vue?vue&type=template&id=d0d995e6&"
import script from "./ChangeEmailNew.vue?vue&type=script&lang=js&"
export * from "./ChangeEmailNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports